// Page Design https://pub.rh.net.sa/rowaad/templates

import React from 'react'
import './TemplatesPage.scss'
import Helmet from 'reactor/components/Helmet'
import PageContent from '../../../components/PageContent'
import BreadcrumbWithImage from '../../../components/BreadcrumbWithImage'
import TemplatesSection from '../TemplatesSection'
import TemplatesTable from '../TemplatesTable'
import BreadcrumbImage from 'assets/images/template_img.png'
import TemplateBack from 'assets/images/template_back.png'
import Heading from '../../../components/heading'


const TemplatesOptions = [
    'السعر',
    'لوحة التحكم',
    'نظام عضويات',
    'نظام الاستفتاءات',
    'تصميم القالب',
    'HTML5, CSS3',
    'تأثيرات jQuery',
    'تصميم متجاوب',
    'اللغة الانجليزية',
    'الاعلانات',
    'وسائط',
    'التصنيفات والصفحات',
    'نموذج الاتصال بنا',
    'التركيب',
    'مثال حي',
    'الطلب'
];


const Templates = [
    {
        templatename: 'الجميعات',
        dashboard: 'لوحة تحكم عربية',
        manage: 'لا يتطلب خبرة مسبقة',
        members: 'التحكم في العضويات',
        questionnaire: 'التحكم في الإستفتاذات',
        design: 'إحترافي متجاوب',
        HTML5CSS3: true,
        jquery: true,
        responsivedesign: true,
        en : true,
        ads: true,
        media: true,
        pages: 'لانهائى',
        contactform: true,
        setUp: true,
        liveLink:"https://demo2.rh.net.sa/templates/charity/template1/",
        price: '2000',
        class: 'associations'
    },
    {
        templatename: 'المحاماة',
        dashboard: 'لوحة تحكم عربية',
        manage: 'لا يتطلب خبرة مسبقة',
        members: 'التحكم في العضويات',
        questionnaire: 'التحكم في الإستفتاذات',
        design: 'إحترافي متجاوب',
        HTML5CSS3: true,
        jquery: true,
        responsivedesign: true,
        en : true,
        ads: true,
        media: true,
        pages: 'لانهائى',
        contactform: true,
        setUp: true,
        liveLink: "https://demo2.rh.net.sa/templates/lawyer/template1/",
        price: '2000',
        class: 'law'
    },
    {
        templatename: 'الشركات',
        dashboard: 'لوحة تحكم عربية',
        manage: 'لا يتطلب خبرة مسبقة',
        members: 'التحكم في العضويات',
        questionnaire: 'التحكم في الإستفتاذات',
        design: 'إحترافي متجاوب',
        HTML5CSS3: true,
        jquery: true,
        responsivedesign: true,
        en : true,
        ads: false,
        media: false,
        pages: 'لانهائى',
        contactform: true,
        setUp: true,
        liveLink: "https://demo2.rh.net.sa/templates/companies/template1/",
        price: '2000',
        class: 'companies'
    },
];

export default function TemplatesPage() {

    return (
        <>
            <Helmet
                bodyClass="templates"
                title="قوالب جاهزة | تصاميم جاهزة لاستخدامات وأغراض مختلفة"
                description="أحصل علي قالب قابل للتخصيص ليناسب احتياجاتك بأسعار مناسبة من رواد، خبرة أكثر من 12 عام في السوق السعودي"
            />

            <BreadcrumbWithImage
                text="قوالب رواد الجاهزة"
                subtext="احصل موقعك الإلكتروني بضغط زر"
                img={BreadcrumbImage}
                back={TemplateBack}
                content="قمنا بتوفير قوالب متعددة الاستخدام تناسب جميع الفئات (شركات - افراد) بأسعار مميزة، وتشكيلة واسعة من قوالب إدارة المحتوى."
            />

            <TemplatesSection/>

           <div>


            <PageContent>
                <Heading
                    title="أختر القالب المناسب لمتطلباتك"
                />
                <TemplatesTable object={Templates} options={TemplatesOptions} />
            </PageContent>
           </div>

        </>
    )
}